<template>
	<router-link class="navbar-item is-size-4" :to="route">
		<font-awesome-icon :icon="icon" />
		<span class="is-size-6">{{ text }}</span>
	</router-link>
</template>

<script>
export default {
	props: ["route", "icon", "text"],
}
</script>
